import {
  IMarketCountryKeyParams,
  marketCountryKeys,
} from './marketCountryKeys';

export type IAssignmentKeyParams = IMarketCountryKeyParams;

export const assignmentKeys = {
  root: (params: IAssignmentKeyParams) =>
    [...marketCountryKeys.root(params), 'assignments'] as const,
  unprocessed: (params: IAssignmentKeyParams) =>
    [...assignmentKeys.root(params), 'unprocessed'] as const,
  countUnprocessed: (params: IAssignmentKeyParams) =>
    [...assignmentKeys.root(params), 'count-unprocessed'] as const,
  active: (params: IAssignmentKeyParams) =>
    [...assignmentKeys.root(params), 'active'] as const,
};

export function parseAssignmentKey<T extends keyof typeof assignmentKeys>(
  queryKey: ReturnType<(typeof assignmentKeys)[T]>
) {
  const [, marketCountry] = queryKey;

  return { marketCountry };
}
